import UpdatedCRMTable from './UpdatedCRMTable';

export default UpdatedCRMTable;
